import AdminModal from "modal/Modal";

class Modal extends AdminModal {

    constructor(settings) {
        super($.extend({"baseClass": "modal", "class": "modal--" + settings.color}, settings));
    }

    buildElement() {
        if (this.built) return;
        this.built = true;

        this.titleIcon = "undefined" !== typeof this.settings.titleIcon;

        this.$element = eotwJSXFactory('div', null, [
            eotwJSXFactory('header', {class: "modal__header"}, [
                eotwJSXFactory('h3', null, [this.settings.title]),
                eotwJSXFactory('button', {class: "modal__close js-close-btn"})
            ]),
            eotwJSXFactory('div', {class: "js-content"}, [
                this.$content
            ]),
            eotwJSXFactory('footer', {class: "modal__footer"}, [
                eotwJSXFactory('a', {href: "mailto:info@sk8hire.co.uk", class: "modal__footer-email"}, ["info@sk8hire.co.uk"]),
                eotwJSXFactory('span', {class: "modal__footer-numbers"}, [eotwJSXFactory('a', {href: "tel:07814600111"}, ["07814 600 111"]),eotwJSXFactory('a', {href: "tel:01926293650"}, ["01926 293 650"])])
            ])
        ]);

        $("." + AdminModal.DEFAULT_SETTINGS.baseClass + "-wrap").append(this.$element);
    }

}

export default Modal;